import { DateTime } from "luxon";

// mui components
import { Stack } from "@mui/material";

// custom components
import Heading3 from "../../../typography/heading-03";
import Heading6 from "../../../typography/heading-06";
import Body3 from "../../../typography/body-03";
import SecondaryButton from "../../../buttons/secondary-button";

// mui icons
import CloseIcon from "@mui/icons-material/Close";
import { ChevronLeftOutlined } from "@mui/icons-material";

// helper utils
import {
	MESSAGE_DRAWER_TYPES,
	MESSAGE_TYPES,
} from "../../../../utils/messages.constants";

// custom styles
import "react-datepicker/dist/react-datepicker.css";
import "../request-closing-date/styles.css";
import styles from "./index.module.scss";

const MessageHistoryDrawer = ({
	handleCloseDrawer,
	drawerData,
	toggleDrawer,
}) => {
	const messageHistoryArr = [...drawerData?.message_history]?.reverse();

	return (
		<Stack direction="column" className={styles.stackContainer}>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				className={styles.drawerHeaderContainer}
			>
				<Heading3
					text={"Message History"}
					extraClass={styles.headerText}
					fontType="semibold"
				/>
				<Stack direction="row" gap={2} alignItems="center">
					<SecondaryButton
						startIcon={<CloseIcon />}
						text="Close"
						onClick={handleCloseDrawer}
					/>
				</Stack>
			</Stack>

			<Stack className={styles.drawerBodyContainer}>
				<SecondaryButton
					text="Go Back"
					startIcon={<ChevronLeftOutlined className={styles.backIcon} />}
					onClick={(e) =>
						toggleDrawer(e, MESSAGE_DRAWER_TYPES.EDIT_MESSAGE, drawerData)
					}
					extraClass={styles.backBtn}
					extraTextClass={styles.backText}
				/>

				<Stack className={styles.messageCardContainer}>
					{messageHistoryArr?.map((message) => (
						<Stack className={styles.messageCard}>
							<Stack className={styles.footerContainer}>
								<Stack>
									<Heading6
										text={`Message ${message?.action}`}
										fontType="semibold"
										extraClass={styles.footerTitle}
									/>
								</Stack>
								<Stack className={styles.footerRightContainer}>
									<Heading6
										text={message?.updated_by_full_name}
										fontType="semibold"
										extraClass={styles.footerText}
									/>
									<Stack className={styles.dotContainer}>
										<Stack className={styles.dot}></Stack>
									</Stack>
									<Heading6
										text={DateTime.fromISO(message?.updated_at, {
											zone: "UTC",
										}).toFormat("MMM dd yyyy, HH:mm")}
										fontType="semibold"
										extraClass={styles.footerText}
									/>
								</Stack>
							</Stack>

							{message?.action?.includes("updated") ? (
								<Stack className={styles.infoContainer}>
									{Object.entries(message?.changes).map(([key, value]) => (
										<Stack className={styles.dataContainer}>
											<Heading6
												text={`${
													key === "body"
														? "Title"
														: key === "end_date"
															? "End Date & Time (UTC)"
															: key === "start_date"
																? "End Date & Time (UTC)"
																: key === "message_type"
																	? "Category"
																	: key
												} updated`}
												fontType="semibold"
												extraClass={styles.dataTitle}
											/>

											<Stack>
												<Body3 text="New" />
												<Body3
													text={
														key.includes("date")
															? `${DateTime.fromISO(value?.new, {
																	zone: "UTC",
																}).toFormat("MMM dd yyyy, HH:mm")} UTC`
															: value?.new === MESSAGE_TYPES.GENERAL
																? "General"
																: value?.new === MESSAGE_TYPES.ROLE_SPECIFIC
																	? "Role Specific"
																	: value?.new === MESSAGE_TYPES.SYSTEM
																		? "System"
																		: value?.new
													}
													extraClass={styles.dataBody}
												/>
											</Stack>

											<Stack>
												<Body3 text="Old" />
												<Body3
													text={
														key.includes("date")
															? `${DateTime.fromISO(value?.old, {
																	zone: "UTC",
																}).toFormat("MMM dd yyyy, HH:mm")} UTC`
															: value?.old === MESSAGE_TYPES.GENERAL
																? "General"
																: value?.old === MESSAGE_TYPES.ROLE_SPECIFIC
																	? "Role Specific"
																	: value?.old === MESSAGE_TYPES.SYSTEM
																		? "System"
																		: value?.old === null
																			? "Empty"
																			: value?.old
													}
													extraClass={styles.dataBody}
												/>
											</Stack>
										</Stack>
									))}
								</Stack>
							) : (
								// Message created card
								<Stack className={styles.infoContainer}>
									{/* Title container */}
									<Stack className={styles.dataContianer}>
										<Heading6
											text="Title"
											fontType="semibold"
											extraClass={styles.dataTitle}
										/>
										<Body3
											text={message?.changes?.title?.new || ""}
											extraClass={styles.dataBody}
										/>
									</Stack>
									{/* Description container */}
									<Stack className={styles.dataContianer}>
										<Heading6
											text="Description"
											fontType="semibold"
											extraClass={styles.dataTitle}
										/>
										<Body3
											text={message?.changes?.body?.new || ""}
											extraClass={styles.dataBody}
										/>
									</Stack>
									{/* Category container */}
									<Stack className={styles.dataContianer}>
										<Heading6
											text="Category"
											fontType="semibold"
											extraClass={styles.dataTitle}
										/>
										<Body3
											text={
												message?.changes?.message_type?.new ===
												MESSAGE_TYPES.GENERAL
													? "General"
													: message?.changes?.message_type?.new ===
														  MESSAGE_TYPES.ROLE_SPECIFIC
														? "Role Specific"
														: message?.changes?.message_type?.new ===
															  MESSAGE_TYPES.SYSTEM
															? "System"
															: ""
											}
											extraClass={styles.dataBody}
										/>
									</Stack>
									{/* Start Date container */}
									<Stack className={styles.dataContianer}>
										<Heading6
											text="Start Date & Time (UTC)"
											fontType="semibold"
											extraClass={styles.dataTitle}
										/>
										<Body3
											text={DateTime.fromISO(
												message?.changes?.start_date?.new,
												{
													zone: "UTC",
												}
											).toFormat("MMM dd yyyy, HH:mm")}
											extraClass={styles.dataBody}
										/>
									</Stack>
									{/* End Date container */}
									<Stack className={styles.dataContianer}>
										<Heading6
											text="End Date & Time (UTC)"
											fontType="semibold"
											extraClass={styles.dataTitle}
										/>
										<Body3
											text={DateTime.fromISO(message?.changes?.end_date?.new, {
												zone: "UTC",
											}).toFormat("MMM dd yyyy, HH:mm")}
											extraClass={styles.dataBody}
										/>
									</Stack>
								</Stack>
							)}
						</Stack>
					))}
				</Stack>
			</Stack>
		</Stack>
	);
};

export default MessageHistoryDrawer;
